module.exports = __webpack_public_path__ + "static/media/pi-thumb.93c397a2.png";